import React from "react";
import NewsletterTemplateEditor from "components/NewsletterTemplateEditor/NewsletterTemplateEditor";

const SecondStep = (props) => {
   return <NewsletterTemplateEditor id={props.id} />;
};

export default SecondStep;
